
const mostrarIdiomaEmpresa = (empresa) => {
    return (empresa['Descrição da empresa (Inglês)']?.trim() !== '' &&  empresa['Descrição da empresa (Inglês)'] !== undefined  ) || 
    (empresa['Descrição da empresa (Espanhol)']?.trim() !== '' && empresa['Descrição da empresa (Espanhol)'] !== undefined) || 
    (empresa['Descrição da empresa (Francês)']?.trim() !== '' && empresa['Descrição da empresa (Francês)'] !== undefined)
    
}

const mostrarIdiomaProduto = (produto) => {
    return (produto['Descrição do produto (Inglês)']?.trim() !== '' && produto['Descrição do produto (Inglês)'] !== undefined) || 
    (produto['Descrição do produto (Espanhol)']?.trim() !== '' && produto['Descrição do produto (Espanhol)'] !== undefined) ||
    (produto['Descrição do produto (Francês)']?.trim() !== '' && produto['Descrição do produto (Francês)'] !== undefined)
}

const validarTextoCondicionalPreenchido = (texto) => {
    return texto !== undefined && texto?.trim() != ''
}

module.exports = { mostrarIdiomaEmpresa, mostrarIdiomaProduto, validarTextoCondicionalPreenchido }